import { render, staticRenderFns } from "./OptInModal.vue?vue&type=template&id=efab9892&scoped=true"
import script from "./OptInModal.vue?vue&type=script&lang=js"
export * from "./OptInModal.vue?vue&type=script&lang=js"
import style0 from "./OptInModal.vue?vue&type=style&index=0&id=efab9892&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efab9892",
  null
  
)

export default component.exports